import { cn } from '@/utils/styles';
import { Image } from '@design-system/Image';
import { Card, CardContent, CardHeader } from '@design-system/Card';

export interface MediaCardProps extends React.ComponentProps<'div'> {
  title: string;
  description?: string;
  thumbnailImage?: string;
}

export const MediaCard = ({
  title,
  className,
  description,
  thumbnailImage,
  ...rest
}: MediaCardProps) => {
  return (
    <Card className={cn('flex flex-row gap-4 p-4 h-32', className)} {...rest}>
      <CardHeader className="p-0">
        <Image
          aria-hidden
          width={80}
          height={80}
          src={thumbnailImage}
          className="size-24 min-w-24 rounded-sm object-fill"
        />
      </CardHeader>

      <CardContent className="p-0 flex flex-col items-start">
        <span className="text-primary typography-h3 font-light line-clamp-2 text-left">
          <abbr title={title} className="no-underline">
            {title}
          </abbr>
        </span>

        {description && (
          <abbr title={description} className="mt-auto no-underline">
            <span className="text-tertiary typography-body truncate">
              {description}
            </span>
          </abbr>
        )}
      </CardContent>
    </Card>
  );
};
